import ShippingRowOpp from "./ShippingRowOpp";
import ShippingDetailModal from "../modals/shipping/ShippingDetailModal";
import {useState} from "react";
import { useTranslation } from "../../hooks/useTranslation";

export default function ShippingTableOpp({shipping}) {
    const { t } = useTranslation();
    const [trackingToShow, setTracking] = useState({
        tracking_id: "",
        shipping_company: "",
    });
    const [showShippingDetailModal, setShowShippingDetailModal] = useState(false);
    return (
        <>
            <ShippingDetailModal
                show={showShippingDetailModal}
                handleClose={() => setShowShippingDetailModal(false)}
                tracking_id={trackingToShow.tracking_id}
                shipping_company={trackingToShow.shipping_company}
            />
            <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable">
                <thead>
                <tr>
                    <th>{t("shipping.trackingId")}</th>
                    <th>{t("common.status")}</th>
                    <th>{t("shipping.lastUpdate")}</th>
                </tr>
                </thead>
                <tbody>
                {shipping.map((row, index) => (
                    <ShippingRowOpp
                        row={row}
                        key={index}
                        selectTracking={(tracking_id, shipping_company) => {
                            setShowShippingDetailModal(true);
                            setTracking({tracking_id, shipping_company});
                        }}
                    />
                ))}
                </tbody>
            </table>
        </>
    );
}
